import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AppError } from '@timechef/core/api';
import { Category } from '@timechef/features/faq/state/faq.models';
import { FaqRepository } from '@timechef/features/faq/state/faq.repository';
import { FaqService } from '@timechef/features/faq/state/faq.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FaqComponent implements OnInit {
  fb: FormBuilder = inject(FormBuilder);
  faqRepo = inject(FaqRepository);
  faqService = inject(FaqService);

  faqAuthenticationDS$ = this.faqRepo.faqAuthenticationDS.data$().pipe(
    map((x) => ({
      ...x,
      data: x.data.map((categorie) => {
        console.log('categorie', categorie);
        return {
          name: categorie.name,
          questions: categorie.questions.map((faqQuestion) => {
            return { ...faqQuestion, showAnswer: false };
          }),
        };
      }),
      error: (x.error as AppError) || null,
    })),
  );

  searchBarCtrl = this.fb.control<string | undefined>({ value: undefined, disabled: false });

  ngOnInit(): void {
    this.faqService.getFaqQuestions().subscribe();
  }

  isEmpty(categories: Category[]) {
    return categories.every((category) => {
      if (category.questions.length !== 0) return false;

      return true;
    });
  }
}
